import { createFileRoute, redirect } from '@tanstack/react-router'
import { CountReviewScreen } from '@/features/inventory-counts/count-review-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/counts/$sessionId/review')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_count.view'))
      throw redirect({ to: '/inventory/counts' })
  },
  component: CountReviewRoute,
})

function CountReviewRoute() {
  const { sessionId } = Route.useParams()

  return <CountReviewScreen sessionId={sessionId} />
}
